import { Component, Input } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { PostProvider } from '../../providers/post/post';

/**
 * Generated class for the PostPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */


@Component({
  selector: 'post-popover',
  templateUrl: 'post-popover.html'
})
export class PostPopoverComponent {

  post_id:string = null;
  canDelete:boolean = false;

  constructor(public navParams: NavParams, private postProvider: PostProvider, private viewCtrl: ViewController) {
    this.post_id = this.navParams.get('post_id')
    this.canDelete = this.navParams.get('canDelete')
  }

  reportPost(){
    this.viewCtrl.dismiss();
  }

  deletePost(){
    this.postProvider.delete(this.post_id).subscribe((res) => {
      if(res.success){
        this.viewCtrl.dismiss();
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/post-popover/post-popover.ts